import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import {
  ArrowDownUp,
  ArrowRight,
  ArrowUpDown,
  SquareCheck,
  SquareX,
} from "lucide-react";
import ReactPaginate from "react-paginate";
import NoData from "../../reusebale/noData";
import ParagraphTag from "../../reusebale/Paragraph";
import LeaseTableLoader from "../../skeleton-loader/lease-table";

import BaseUrl from "../../../constants/BaseUrl";
import db from "../../../db/index.json";

const TenantsTable = ({ onViewDetails, selectedTenant, searchTerm }) => {
  const { loginSuccess } = useSelector((state) => state.auth);
  const [loading, setLoading] = useState(false);
  const [totalData, setTotalData] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const { tenants } = db;

  const [data, setData] = useState([]);
  const [filteredTenants, setFilteredTenants] = useState([]);

  const GetAllTenant = () => {
    setLoading(true);
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${loginSuccess?.token}`);
    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      `${BaseUrl}tenant/getAllTenants?page=${currentPage}&limit=${itemsPerPage}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.success) {
          setLoading(false);
          setData(result.data);
          setTotalData(result.pagination.totalItems);
        } else {
          setLoading(false);
        }
      })
      .catch((error) => console.error(error));
  };

  useEffect(() => {
    GetAllTenant();
  }, [currentPage]);

  const handlePageClick = (selectedPage) => {
    setCurrentPage(selectedPage.selected + 1);
  };

  // State for sorting
  const [sortConfig, setSortConfig] = useState({
    key: "lease",
    direction: "asc",
  });

  // Filter tenants based on search term
  useEffect(() => {
    if (!searchTerm || searchTerm.trim() === "") {
      setFilteredTenants(data);
    } else {
      const filtered = data.filter((tenant) => {
        const firstName = tenant?.firstName?.toLowerCase() || "";
        const lastName = tenant?.lastName?.toLowerCase() || "";
        const email = tenant?.email?.toLowerCase() || "";
        const fullName = `${firstName} ${lastName}`.toLowerCase();

        return (
          firstName.includes(searchTerm.toLowerCase()) ||
          lastName.includes(searchTerm.toLowerCase()) ||
          fullName.includes(searchTerm.toLowerCase()) ||
          email.includes(searchTerm.toLowerCase())
        );
      });
      setFilteredTenants(filtered);
    }
  }, [data, searchTerm]);

  useEffect(() => {
    setFilteredTenants(data);
  }, [data]);

  console.log("filteredTenants", filteredTenants);

  const requestSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
    const sortedData = [...filteredTenants].sort((a, b) => {
      if (a[key] < b[key]) {
        return direction === "asc" ? -1 : 1;
      }
      if (a[key] > b[key]) {
        return direction === "asc" ? 1 : -1;
      }
      return 0;
    });
    setFilteredTenants(sortedData);
  };

  return (
    <div className="h-full">
      <div className="bg-white overflow-y-auto panelScroll w-full h-[87%] ">
        <div className="w-[95%] mx-auto">
          <div className="flex items-center h-[12%]">
            <ParagraphTag
              content={tenants.heading}
              classes="text-darkColor font-popinsSemiBold text-lg py-5"
            />
          </div>
          <div className="overflow-y-scroll w-full h-[88%] panelScroll pt-2">
            <table className="w-full ">
              <thead className="sticky top-0 bg-white">
                <tr>
                  <th className="w-[23%] text-left">
                    <span className="flex">
                      <ParagraphTag
                        content={tenants.heading}
                        classes="text-darkColor/40 font-popinsSemiBold text-xs pr-1"
                      />
                      {sortConfig.key === "lease" ? (
                        sortConfig.direction === "asc" ? (
                          <ArrowUpDown
                            className="cursor-pointer"
                            size={13}
                            color="#6F6F6F"
                            onClick={() => requestSort("property")}
                          />
                        ) : (
                          <ArrowDownUp
                            className="cursor-pointer"
                            size={13}
                            color="#6F6F6F"
                            onClick={() => requestSort("property")}
                          />
                        )
                      ) : (
                        <ArrowUpDown
                          className="cursor-pointer"
                          size={13}
                          color="#6F6F6F"
                          onClick={() => requestSort("property")}
                        />
                      )}
                    </span>
                  </th>
                  <th className="w-[17%]">
                    <span className="flex justify-center">
                      <ParagraphTag
                        content={tenants.email}
                        classes="text-darkColor/40 font-popinsSemiBold text-xs pr-1"
                      />
                      {sortConfig.key === "email" ? (
                        sortConfig.direction === "asc" ? (
                          <ArrowUpDown
                            className="cursor-pointer"
                            size={13}
                            color="#6F6F6F"
                            onClick={() => requestSort("email")}
                          />
                        ) : (
                          <ArrowDownUp
                            className="cursor-pointer"
                            size={13}
                            color="#6F6F6F"
                            onClick={() => requestSort("email")}
                          />
                        )
                      ) : (
                        <ArrowUpDown
                          className="cursor-pointer"
                          size={13}
                          color="#6F6F6F"
                          onClick={() => requestSort("email")}
                        />
                      )}
                    </span>
                  </th>
                  <th className="w-[15%]">
                    <span className="flex justify-center">
                      <ParagraphTag
                        content={tenants.emailVerify}
                        classes="text-darkColor/40 font-popinsSemiBold text-xs pr-1"
                      />
                      {sortConfig.key === "emailVerify" ? (
                        sortConfig.direction === "asc" ? (
                          <ArrowUpDown
                            className="cursor-pointer"
                            size={13}
                            color="#6F6F6F"
                            onClick={() => requestSort("emailVerify")}
                          />
                        ) : (
                          <ArrowDownUp
                            className="cursor-pointer"
                            size={13}
                            color="#6F6F6F"
                            onClick={() => requestSort("emailVerify")}
                          />
                        )
                      ) : (
                        <ArrowUpDown
                          className="cursor-pointer"
                          size={13}
                          color="#6F6F6F"
                          onClick={() => requestSort("emailVerify")}
                        />
                      )}
                    </span>
                  </th>
                  <th className="w-[15%]">
                    <span className="flex justify-center">
                      <ParagraphTag
                        content={tenants.phone}
                        classes="text-darkColor/40 font-popinsSemiBold text-xs pr-1"
                      />
                      {sortConfig.key === "phone" ? (
                        sortConfig.direction === "asc" ? (
                          <ArrowUpDown
                            className="cursor-pointer"
                            size={13}
                            color="#6F6F6F"
                            onClick={() => requestSort("phone")}
                          />
                        ) : (
                          <ArrowDownUp
                            className="cursor-pointer"
                            size={13}
                            color="#6F6F6F"
                            onClick={() => requestSort("phone")}
                          />
                        )
                      ) : (
                        <ArrowUpDown
                          className="cursor-pointer"
                          size={13}
                          color="#6F6F6F"
                          onClick={() => requestSort("phone")}
                        />
                      )}
                    </span>
                  </th>
                  <th className="w-[15%] text-right pr-4">
                    <ParagraphTag
                      content={tenants.actions}
                      classes="text-darkColor/40 font-popinsSemiBold text-xs"
                    />
                  </th>
                </tr>
              </thead>
              <tbody>
                {filteredTenants.map((item) => (
                  <tr key={item.id} className="hover:bg-gray-100 rounded-md">
                    <td className="py-1">
                      <div className="flex items-center justify-between">
                        <div className="w-full">
                          <ParagraphTag
                            content={`TEN-${item?._id?.slice(0, 10)}`}
                            classes="text-darkColor/50 font-popinsMedium text-xs"
                          />
                          <ParagraphTag
                            content={`${item.firstName} ${item.lastName}`}
                            classes="text-darkColor font-popinsSemiBold text-sm"
                          />
                        </div>
                      </div>
                    </td>
                    <td className="py-1 font-popinsMedium text-darkColor text-sm">
                      <ParagraphTag
                        content={`${item.email}`}
                        classes="text-darkColor font-popinsSemiBold text-sm"
                      />
                    </td>
                    <td className="py-1 px-4 font-popinsMedium text-darkColor text-sm text-center">
                      <div className="flex justify-center items-center">
                        {(() => {
                          switch (item.emailVerified) {
                            case true:
                              return <SquareCheck color="#01CB78" size={20} />; // Green check for true
                            case false:
                              return <SquareX color="#E43B3B" size={20} />; // Red cross for false
                            default:
                              return null; // In case `emailVerified` is undefined or null
                          }
                        })()}
                      </div>
                    </td>
                    <td className="py-1 px-4 font-popinsMedium text-darkColor text-sm text-center">
                      {item.cellNo}
                    </td>
                    <td className="py-1 px-4 font-popinsMedium text-darkColor text-sm">
                      <div className="flex justify-end pr-3">
                        <div
                          className="flex justify-center items-center border border-themeColor w-7 h-7 rounded-md cursor-pointer"
                          onClick={() => {
                            onViewDetails(item);
                          }}
                        >
                          <ArrowRight
                            color="#6F6F6F"
                            size={18}
                            strokeWidth={2}
                          />
                        </div>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            {loading && <LeaseTableLoader />}
            {!loading && filteredTenants.length === 0 && data.length > 0 && (
              <div className="w-full mt-5 text-center">
                <p className="text-gray-500 font-popinsRegular">
                  No tenants found matching your search.
                </p>
              </div>
            )}
            {data.length === 0 && !loading && (
              <div className="w-full flex justify-center mt-5">
                <NoData />
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="flex justify-center items-center h-[13%]">
        <ReactPaginate
          previousLabel="Previous"
          nextLabel="Next"
          breakLabel="..."
          pageCount={Math.ceil(totalData / itemsPerPage)}
          marginPagesDisplayed={2}
          pageRangeDisplayed={3}
          onPageChange={handlePageClick}
          containerClassName="flex space-x-2 items-center"
          pageClassName="px-3 py-1 border rounded-md text-sm font-popinsMedium cursor-pointer"
          previousClassName="px-3 py-1 border rounded-l-md text-sm cursor-pointer font-popinsMedium"
          nextClassName="px-3 py-1 border rounded-r-md text-sm font-popinsMedium cursor-pointer font-popinsMedium"
          disabledClassName="opacity-50 !cursor-not-allowed"
          activeClassName="bg-themeColor text-white"
          breakClassName="px-3 py-1 text-sm font-popinsMedium"
        />
      </div>
    </div>
  );
};

export default TenantsTable;
